/**
 * Currency formatting shared by Direct Sale and the Seller Creator. One
 * implementation for the price bar, the position pills, the checkout and the
 * publish summary so no two surfaces can ever format the same amount
 * differently.
 *
 * Direct Sale amounts arrive as decimal STRINGS from the server quote /
 * catalog payload (money is never computed client-side); the creator's
 * selling prices and profits are numbers it holds in its own state. Either
 * way parsing happens only for display, in the language the caller passes
 * (`i18n.language`).
 */
export function formatMoney(
  amount: string | number,
  currency: string,
  language: string
): string {
  return new Intl.NumberFormat(language, {
    style: 'currency',
    currency,
  }).format(Number(amount));
}
